<template>
<v-container class="ma-0 pa-0" fluid style="display: grid; justify-content: center; align-items: center; min-height: 100%; background-color: #fff">
  <div style="padding-bottom: 50px;">
  <v-card flat class="ma-0 pa-0" max-width="700px">
    <v-alert
      prominent
      outlined
      text
      border="top"
      color="info"
      class="mb-0">
      <div class="alert-container">
        <div style="display: grid; justify-content: center; align-items: center; align-content: flex-end;">
          <v-icon
            color="info"
            class="alert-icon">
            mdi-information-outline
          </v-icon>
        </div>
        <v-row align="center">
          <v-col>
            Per message communicated on 3/10/2026 via promoportal@argretailers.com,<br> 
            your account is disabled from <strong>3/23/2026 through 3/29/2026</strong> while ARG makes updates.
            <strong>Your access will be restored 3/30/2026.</strong><br><br>
            Any issues or questions can be directed to your category manager.<br><br>
            <strong>
              Thank you,<br>
              Alliance Retail Group
            </strong>
          </v-col>
        </v-row>
      </div>
    </v-alert>
  </v-card>
  </div>
</v-container>
</template>
<script>
export default {
  name: 'VendorAccessDisabled'
}
</script>
<style scoped>
.alert-container {
  display: grid;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin: 10px 25px;
}

.alert-icon {
  background: rgb(33 150 243 / 10%);
  border: 1px solid transparent;
  border-radius: 50%;
  padding: 14px 15px;
}
</style>